module.exports = __webpack_public_path__ + "img/tieng-nhat-can-tho-new-windows-quoc-ky-nhat2.de2342a4.jpg";